import {
  Children,
  type CSSProperties,
  type HTMLAttributes,
  type ReactNode,
} from "react";

interface ScenarioFlowSceneProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  sceneId?: string;
  children?: ReactNode;
}

function ScenarioFlowScene({
  title = "场景",
  children,
  style,
  ...restProps
}: ScenarioFlowSceneProps) {
  const hasFlowChildren = Children.count(children) > 0;
  const sceneStyle: CSSProperties = {
    width: 280,
    border: "1px solid #f0f0f0",
    borderRadius: 8,
    padding: 12,
    boxSizing: "border-box",
    background: "#fff",
    ...style,
  };

  return (
    <div {...restProps} style={sceneStyle}>
      <div
        style={{
          background: "#25b4ff",
          color: "#0f172a",
          fontWeight: 600,
          fontSize: 14,
          borderRadius: 6,
          padding: "6px 8px",
          marginBottom: 12,
        }}
      >
        {title}
      </div>
      <div
        data-partial-drop-zone="true"
        style={{
          minHeight: 96,
          borderRadius: 6,
          background: hasFlowChildren ? "transparent" : "#fafafa",
          border: hasFlowChildren ? "none" : "1px dashed #d9d9d9",
          padding: hasFlowChildren ? 0 : 12,
          boxSizing: "border-box",
        }}
      >
        {hasFlowChildren ? (
          children
        ) : (
          <div
            style={{
              minHeight: 72,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#8c8c8c",
              fontSize: 12,
              textAlign: "center",
            }}
          >
            拖拽流程节点到此区域
          </div>
        )}
      </div>
    </div>
  );
}

export default ScenarioFlowScene;
